export const PWA_VOICE_COMMANDS_ENABLED_KEY = 'boox_pwa_voice_commands_enabled';

function readBoolean(key: string, fallback = false): boolean {
  if (typeof window === 'undefined') return fallback;
  return window.localStorage.getItem(key) === '1';
}

export function isPwaVoiceCommandsEnabled(): boolean {
  return readBoolean(PWA_VOICE_COMMANDS_ENABLED_KEY, false);
}

export function setPwaVoiceCommandsEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(PWA_VOICE_COMMANDS_ENABLED_KEY, enabled ? '1' : '0');
}
